import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import upperFirst from 'lodash/upperFirst';

import env from 'Env';
import ReviewScoreLogo from 'Components/Product/CriticReviews/ReviewScoreLogo';
import ProductCriticReviewCard from 'Components/Product/CriticReviews/ProductCriticReviewCard';

import 'Components/Product/CriticReviews/ProductCriticReviews.scss';

const ReviewTab = ({ isActive, onClick, label }) =>
  <button
    className={classNames('ProductCriticReviews__topContainer__tabs__tab', { 'ProductCriticReviews__topContainer__tabs__tab--active': isActive })}
    onClick={onClick}
  >
    {label}
  </button>;

const ProductCriticReviews = ({ product, newDesign }) => {
  const recommendedThreshold = env.percentRecommendedThreshold;
  const showMetaCritic = get(product, 'metaCritic.score') >= recommendedThreshold && get(product, 'metaCritic.reviews.length', 0) >= 3;
  const showOpenCritic = get(product, 'openCritic.score') >= recommendedThreshold && get(product, 'openCritic.reviews.length', 0) >= 3;
  const [activeTab, setActiveTab] = useState(showMetaCritic ? 'metaCritic' : 'openCritic');
  const [expandCards, setExpandCards] = useState(false);

  if (!showMetaCritic && !showOpenCritic) return null;

  return (
    <section className={classNames('ProductCriticReviews', { 'ProductCriticReviews--newDesign': newDesign })}>
      <div className="ProductCriticReviews__topContainer">
        <div className="ProductCriticReviews__topContainer__heading">
          <h2 className="ProductCriticReviews__topContainer__title">
            <FormattedMessage id="product.critic.reviews.title" defaultMessage="Critic Reviews" />
          </h2>
          {showMetaCritic && activeTab === 'metaCritic' && (
            <ReviewScoreLogo
              reviewCount={product.metaCritic.reviewCount}
              logo={activeTab}
              score={product.metaCritic.score}
            />
          )}
          {showOpenCritic && activeTab === 'openCritic' && (
            <ReviewScoreLogo
              reviewCount={product.openCritic.reviewCount}
              logo={activeTab}
              score={product.openCritic.score}
            />
          )}
        </div>
        {!newDesign && showMetaCritic && showOpenCritic && (
          <div className="ProductCriticReviews__topContainer__tabs">
            <ReviewTab isActive={activeTab === 'metaCritic'} label="MetaCritic" onClick={() => setActiveTab('metaCritic')} />
            <ReviewTab isActive={activeTab === 'openCritic'} label="OpenCritic" onClick={() => setActiveTab('openCritic')} />
          </div>
        )}
      </div>

      {activeTab === 'metaCritic' && newDesign &&

        <div className="ProductCriticReviews__metacritic">
          <div className="ProductCriticReviews__metacritic__reviews">
            {product.metaCritic.reviews.map(review => (
              <article className="ProductCriticReviews__metacritic__card">
                <div className="ProductCriticReviews__metacritic__card__scoreReviewer">
                  <div className="ProductCriticReviews__metacritic__card__scoreReviewer__score">
                    {review.displayScore}
                  </div>
                  <div className="ProductCriticReviews__metacritic__card__scoreReviewer__reviewer">
                    {review.outletName}
                  </div>
                </div>
                <div className="ProductCriticReviews__metacritic__card__review">
                  {review.message}
                </div>
              </article>
            ))}
          </div>
          <div className="ProductCriticReviews__metacritic__link">
            <FormattedMessage
              id="product.critic.reviews.providedby"
              defaultMessage="Reviews provided by {link}"
              values={{
                link: <a href={product[activeTab].url} target="_blank" rel="noopener noreferrer nofollow">{upperFirst(activeTab)}</a>,
              }}
            />
          </div>
        </div>
      }

      {(activeTab === 'openCritic' || (activeTab === 'metaCritic' && !newDesign)) &&
        <div className={`ProductCriticReviews__content page-section-margin ${activeTab}`}>
          <div className="ProductCriticReviews__content__cards">
            {product[activeTab].reviews.map(review => (
              <ProductCriticReviewCard
                key={review.url}
                expandCards={expandCards}
                review={review}
                setExpandCards={setExpandCards}
                newDesign={newDesign}
              />
            ))}
          </div>
          <div className="text-muted text-center mt-2">
            <FormattedMessage
              id="product.critic.reviews.providedby"
              defaultMessage="Reviews provided by {link}"
              values={{
                link: <a href={product[activeTab].url} target="_blank" rel="noopener noreferrer nofollow">{upperFirst(activeTab)}</a>,
              }}
            />
          </div>
        </div>
      }
    </section>
  );
};

ProductCriticReviews.propTypes = {
  product: PropTypes.shape({}).isRequired,
  newDesign: PropTypes.bool,
};

ProductCriticReviews.defaultProps = {
  newDesign: false,
};

export default ProductCriticReviews;
